export default {
  SET_DEALER_USERS: (state, data) => {
    state.dealerUsers = data;
  },
  SET_DEALER_USER: (state, data) => {
    state.dealerUser = data;
  },
};
